import { useaxios } from "../../../utils/useaxios";
export default (company_invoice_id, items) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('company_invoice/update.php', { company_invoice_id, items }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setcompanyinvoiceitem', payload: [] });
            setrecaller(recaller + 1);
        } else {
            clear();
        }
        // setloading(false);
    });
}